export default __webpack_public_path__ + "static/media/2.89929959.png";